(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["hh-project-quote-banner"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('hh-project-quote')) {
    customElements.define('hh-project-quote', class extends HTMLElement {
      connectedCallback() {
        if (this.controller) return;
        this.controller = new AbortController();
        const options = { signal: this.controller.signal };
        this.panel = this.querySelector('.hhpq__panel');
        this.launcher = this.querySelector('.hhpq__launcher');
        this.closeButton = this.querySelector('.hhpq__close');
        this.launcher.setAttribute('aria-expanded', 'false');
        this.setAttribute('data-enhanced', 'true');
        this.pinned = false;
        this.pointerInside = false;
        this.suppressFocus = false;
        this.pointerDown = false;
        this.hover = window.matchMedia('(hover: hover) and (pointer: fine)');
        this.addEventListener('pointerenter', (event) => {
          if (event.pointerType !== 'mouse' || !this.hover.matches) return;
          this.pointerInside = true;
          window.clearTimeout(this.closeTimer);
          this.setOpen(true);
        }, options);
        this.addEventListener('pointerleave', () => {
          this.pointerInside = false;
          this.scheduleClose();
        }, options);
        this.launcher.addEventListener('pointerdown', () => { this.pointerDown = true; }, options);
        this.launcher.addEventListener('click', (event) => {
          event.preventDefault();
          this.pointerDown = false;
          if (this.pinned) this.dismiss(false);
          else { this.pinned = true; this.suppressFocus = false; this.setOpen(true); }
        }, options);
        this.addEventListener('focusin', () => {
          window.clearTimeout(this.closeTimer);
          if (!this.suppressFocus && !this.pointerDown) this.setOpen(true);
        }, options);
        this.addEventListener('focusout', (event) => {
          if (!this.contains(event.relatedTarget)) {
            this.suppressFocus = false;
            this.pointerDown = false;
            this.pinned = false;
            this.scheduleClose();
          }
        }, options);
        this.closeButton.addEventListener('click', (event) => { event.preventDefault(); this.dismiss(true); }, options);
        document.addEventListener('keydown', (event) => {
          if (event.key === 'Escape' && this.panel.matches(':popover-open')) this.dismiss(this.contains(document.activeElement));
        }, options);
        document.addEventListener('pointerdown', (event) => {
          if (!this.contains(event.target)) this.dismiss(false);
        }, options);
        this.panel.addEventListener('toggle', () => {
          this.launcher.setAttribute('aria-expanded', String(this.panel.matches(':popover-open')));
        }, options);
        this.checkObstructions = () => {
          window.cancelAnimationFrame(this.obstructionFrame);
          this.obstructionFrame = window.requestAnimationFrame(() => {
            const consent = document.querySelector('#shopify-pc__banner');
            const rect = consent?.getBoundingClientRect();
            const visible = Boolean(rect?.width && rect?.height && getComputedStyle(consent).visibility !== 'hidden' && getComputedStyle(consent).display !== 'none');
            this.toggleAttribute('data-obstructed', visible);
            if (visible) this.dismiss(false);
          });
        };
        this.observer = new MutationObserver((records) => {
          if (records.some((record) => !this.contains(record.target))) this.checkObstructions();
        });
        this.observer.observe(document.body, { childList: true, subtree: true, attributes: true, attributeFilter: ['class', 'style', 'hidden'] });
        window.addEventListener('resize', this.checkObstructions, options);
        this.checkObstructions();
      }
      setOpen(open) {
        window.clearTimeout(this.closeTimer);
        if (open && !this.panel.matches(':popover-open')) this.panel.showPopover();
        if (!open && this.panel.matches(':popover-open')) this.panel.hidePopover();
        this.launcher.setAttribute('aria-expanded', String(open));
      }
      scheduleClose() {
        window.clearTimeout(this.closeTimer);
        this.closeTimer = window.setTimeout(() => {
          if (!this.pinned && !this.pointerInside && !this.contains(document.activeElement)) this.setOpen(false);
        }, 180);
      }
      dismiss(returnFocus) {
        this.pinned = false;
        this.suppressFocus = true;
        this.setOpen(false);
        if (returnFocus) this.launcher.focus({ preventScroll: true });
      }
      disconnectedCallback() {
        this.controller?.abort();
        this.controller = null;
        this.observer?.disconnect();
        window.clearTimeout(this.closeTimer);
        window.cancelAnimationFrame(this.obstructionFrame);
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
